import React, { useEffect } from 'react'
import { generatePresignedUrl } from '../../helpers/s3'
import use3DViewer from '../../hooks/use3DViewer'
import { getDesignLayoutForUnitPlan } from '../../helpers/data'

function ModelsPrefetcher({ selectedLine, selectedLevel }) {

  const { send } = use3DViewer(null, '3d-viewer')
  useEffect(() => {
    ;(async () => {
      const plans = selectedLine.packages
        .map((p) => p.unit_plans)
        .flat()
        .filter((p) => p.unit_type_level.id === selectedLevel.id)
        .map((p) => {
          return (getDesignLayoutForUnitPlan(p).models[0] || {}).high_res_model_path
        })
      // Remove first model since it's loaded once line is viewed
      plans.shift()
      // Pre-fetch models for the rest of the plans
      const urls = await Promise.all(plans.map((plan) => generatePresignedUrl(`${plan}.glb`)))
      send('url-prefetch', { urls })
    })()
  }, [selectedLine, selectedLevel])

  return <></>
}

export default ModelsPrefetcher
